module.exports = __webpack_public_path__ + "img/fatigue.81784e83.svg";